<template>
    <div class="card abtg__default-card abtg__orangeborder-bottom">
        <div class="card-body abtg__table-border">
            <div class="row">
                <div class="col-10 offset-1">
                    <div class="row">
                        <div class="col-lg-3">
                            <div class="form-group">
                                <label>Categoria*</label>
                                <multiselect :options="categoriesList" track-by="nome" label="nome" :placeholder="''"
                                             :preserve-search="true" :class="'abtg__multiselect-form-control'"
                                             :selectLabel="'Clicca per selezionare'" :selectedLabel="'Selezionato'"
                                             :deselectLabel="'Clicca per rimuovere'" v-model="formData.category"
                                             :searchable="true" :close-on-select="true"
                                             @input="setTypologies(formData.category.id)">
                                    <template slot="noResult">
                                        Nessun Risultato.
                                    </template>
                                </multiselect>
                            </div>
                        </div>
                        <div class="col-lg-3">
                            <div class="form-group">
                                <label>Tipologia*</label>
                                <multiselect :options="typologiesList" track-by="nome" label="nome" :placeholder="''"
                                             :preserve-search="true" :class="'abtg__multiselect-form-control'"
                                             :selectLabel="'Clicca per selezionare'" :selectedLabel="'Selezionato'"
                                             :deselectLabel="'Clicca per rimuovere'" v-model="formData.typology"
                                             :searchable="true" :close-on-select="true">
                                    <template slot="noResult">
                                        Nessun Risultato.
                                    </template>
                                </multiselect>
                            </div>
                        </div>
                        <div class="col-lg-3">
                            <div class="form-group">
                                <label>Tribunale*</label>
                                <multiselect :options="tribunalsList" track-by="nome" label="nome" :placeholder="''"
                                             :preserve-search="true" :class="'abtg__multiselect-form-control'"
                                             :selectLabel="'Clicca per selezionare'" :selectedLabel="'Selezionato'"
                                             :deselectLabel="'Clicca per rimuovere'" v-model="formData.tribunal"
                                             :searchable="true" :close-on-select="true">
                                    <template slot="noResult">
                                        Nessun Risultato.
                                    </template>
                                </multiselect>
                            </div>
                        </div>
                        <div class="col-lg-3">
                            <div class="form-group">
                                <label>Comune</label>
                                <input type="text" v-model="formData.city" class="form-control" name="city"/>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-lg-4">
                            <div class="form-group">
                                <label>RGE/ANNO</label>
                                <input type="text" v-model="formData.rge_year" class="form-control" name="rge_year"/>
                            </div>
                        </div>
                        <div class="col-lg-8">
                            <div class="form-group">
                                <label>Base d'asta</label>
                                <vue-slider v-model="rangeValue"
                                            :process="processStyle"
                                            :dotOptions="dotOption"
                                            :min="0"
                                            :max="1000000"
                                            :interval="100"
                                            :tooltip="'always'"
                                            :tooltip-placement="'bottom'"
                                            :tooltip-formatter="currencyFormatter">
                                </vue-slider>
                            </div>
                        </div>
                    </div>

                    <div class="row" v-if="1 === 2">
                        <div class="col-lg-3">
                            <div class="form-group">
                                <label>Data di pubblicazione - inizio</label>
                                <date-picker v-model="formData.publish_date_start" lang="it" placeholder=""
                                             format="DD/MM/YYYY"></date-picker>
                            </div>
                        </div>
                        <div class="col-lg-3">
                            <div class="form-group">
                                <label>Data di pubblicazione - fine</label>
                                <date-picker v-model="formData.publish_date_end" lang="it" placeholder=""
                                             format="DD/MM/YYYY"></date-picker>
                            </div>
                        </div>
                        <div class="col-lg-3">
                            <div class="form-group">
                                <label>Data di vendita - inizio</label>
                                <date-picker v-model="formData.sold_date_start" lang="it" placeholder=""
                                             format="DD/MM/YYYY"></date-picker>
                            </div>
                        </div>
                        <div class="col-lg-3">
                            <div class="form-group">
                                <label>Data di vendita - fine</label>
                                <date-picker v-model="formData.sold_date_end" lang="it" placeholder=""
                                             format="DD/MM/YYYY"></date-picker>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-lg-12">
                            <button type="button" class="btn pull-right shadow-none abtg__btn-tool abtg__btn-third"
                                    @click="sendSearchFilters">
                                Cerca <i class="fas fa-sync-alt fa-spin" v-if="showLoading"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col">


                    <div class="table-responsive">
                        <div style="margin-top:30px;" v-if="showLoading">
                            <hr>
                            <p class="text-center"><i class="fas fa-sync fa-spin fa-3x"
                                                      style="color:#EF7621"></i></p>
                            <p class="text-center">Sto cercando</p>
                        </div>
                        <div v-else>
                            <hr>
                        </div>

                        <table
                                v-if="buildingList.length > 0"
                                class="mdl-data-table ml-table-striped ml-table-bordered mdl-js-data-table  is-upgraded abtg__auction_table_td">
                            <thead>
                            <tr>
                                <th class="mdl-data-table__cell--non-numeric text-left">Tribunale</th>
                                <th class="mdl-data-table__cell--non-numeric text-left">RGE/ANNO</th>

<!--                                <th class="mdl-data-table__cell&#45;&#45;non-numeric text-left">#Lotto</th>-->
                                <th class="mdl-data-table__cell--non-numeric text-left">Data pubblicazione</th>
                                <th class="mdl-data-table__cell--non-numeric text-left">Indirizzo - Categoria -
                                    Tipologia
                                </th>
                                <th class="mdl-data-table__cell--non-numeric text-left">Data Vendita
                                    <i class="fas fa-sort-amount-up abtg__label-color-custom"
                                       @click="handlingSort('date')"
                                       v-show="sortDate === false"></i>
                                    <i class="fas fa-sort-amount-down abtg__label-color-custom"
                                       @click="handlingSort('date')"
                                       v-show="sortDate === true"></i>
                                </th>
                                <th class="mdl-data-table__cell--non-numeric text-left">Base d'asta
                                    <i class="fas fa-sort-amount-up abtg__label-color-custom"
                                       @click="handlingSort('baseAuction')"
                                       v-show="sortBaseAuction === false"></i>
                                    <i class="fas fa-sort-amount-down abtg__label-color-custom"
                                       @click="handlingSort('baseAuction')"
                                       v-show="sortBaseAuction === true"></i>
                                </th>

                                <th class="mdl-data-table__cell--non-numeric text-left">Offerta min.

                            </th>
                                <th class="mdl-data-table__cell--non-numeric text-left">Rialzo min.

                                </th>
<!--                                <th class="mdl-data-table__cell&#45;&#45;non-numeric text-left">Mq</th>-->


                                <th class="mdl-data-table__cell--non-numeric text-center">
                                    <input type="checkbox"
                                           @click="selectAll">
                                </th>
                            </tr>
                            </thead>
                            <tbody>


                            <tr v-for="(building, index) in filteredList">

                                <td style="white-space: normal;">
                                    {{building.dettaglio_procedura.tribunale}}
                                </td>
                                <td style="white-space: normal;">{{building.dettaglio_procedura.nr_procedura}}</td>
<!--                                <td style="white-space: normal;">-->
<!--                                    {{building.dettaglio_procedura['lotto_nr.']}}-->
<!--                                </td>-->
                                <td style="white-space: normal;">
                                    {{building.dettaglio_procedura.pubblicato_sul_portale_il}}
                                </td>
                                <td style="white-space: normal;">
                                    {{building.indirizzo}} <br>
                                    {{ building.categoria}} - {{building.tipologia}}
                                   <br> <a :href="building.link" target="_blank">Link dettaglio asta</a>
                                </td>
                                <td style="white-space: normal;">{{building.dettaglio_vendita.data_di_vendita.substr(0,10)}}</td>
                                <td><i class="fas fa-euro-sign"></i>
                                    {{building.dettaglio_vendita['prezzo_base_d\'asta']}}
                                </td>

                                <td><i class="fas fa-euro-sign"></i>
                                    {{building.dettaglio_vendita['offerta_minima']}}
                                </td>

                                <td><i class="fas fa-euro-sign"></i>
                                    {{building.dettaglio_vendita['rialzo_minimo']}}
                                </td>
<!--                                <td style="white-space: normal;">{{building.beni_lotto[0].superficie}}</td>-->

                                <td style="white-space: normal;">
                                    <div class="btn-group  " role="group">

                                        <input type="checkbox"
                                               :value="building.link"
                                               v-model="checkedBuildings">
                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

        <div class="card-footer">
            <h3
                    class="text-center"
                    v-if="showMessageImportCompleted">Gli immobili sono stati importati: <a href="/auction/">vai all'archivio aste per gestirli</a>.</h3>
            <p class="float-right" v-if="!showMessageImportCompleted">
                <button type="submit"
                        v-if="showImportBtn"
                        class="btn  btn-block  abtg__default-button m-t-20 abtg__btn-star shadow-none"
                        @click.prevent="onImportData()" style="font-size:100%;">
                    Importa aste
                </button>
            </p>
        </div>
    </div>
</template>

<script>
    import {createHelpers} from 'vuex-map-fields';
    import DatePicker from 'vue2-datepicker';
    import {mixin} from '../../helpers/helper'
    import {Money} from 'v-money';
    import saveOk from '../commons/saveok';
    import modal from '../commons/modal';
    import VueSlider from 'vue-slider-component'
    import 'vue-slider-component/theme/antd.css'
    import multiselect from 'vue-multiselect';
    import 'vue-multiselect/dist/vue-multiselect.min.css';

    const {mapFields} = createHelpers({
        getterType: 'auctionmapping/getField',
        mutationType: 'auctionmapping/updateField',
    });

    export default {
        data: function () {
            return {
                sortBaseAuction: false,
                sortDate: false,
                priorityDate: false,
                priorityBaseAuction: false,
                isAllSelected: false,
                rangeValue: [0, 200000],
                currencyFormatter: v => ('€ ' + v).replace(/\B(?=(\d{3})+(?!\d))/g, '.'),
                processStyle: dotsPos => [[dotsPos[0], dotsPos[1], {backgroundColor: '#EF7B10'}]],
                dotOption: {
                    style: {backgroundColor: '#EF7B10', borderColor: '#EF7B10'},
                    focusStyle: {boxShadow: '0 0 0 5px rgba(239, 123, 16, 0.2)'}
                },
            }
        },
        mixins: [mixin],
        components: {
            DatePicker,
            Money,
            saveOk,
            modal,
            VueSlider,
            multiselect
        },
        created: function () {
            this.initAuctionMapping();
        },
        computed: {
            ...mapFields(['showMessageImportCompleted', 'formData', 'categoriesList', 'tribunalsList', 'typologiesList', 'buildingList', 'checkedBuildings', 'showLoading', 'showImportBtn']),

            filteredList(){
                this.filteredData =  this.buildingList;

                if (this.filteredData) {
                    return this.filteredData.sort( (a, b) => {
                        if (this.priorityBaseAuction === true) {
                            let baseA = a.dettaglio_vendita['prezzo_base_d\'asta'].replace(/\./g, '').replace(/\,/g, '.');
                            let baseB = b.dettaglio_vendita['prezzo_base_d\'asta'].replace(/\./g, '').replace(/\,/g, '.');
                            return this.sortBaseAuction === true ? baseB -  baseA
                                :  baseA -  baseB;
                        }

                        if (this.priorityDate === true) {
                            let dateA = new Date(a.dettaglio_vendita.data_di_vendita.substr(0,10)).getTime();
                            let dateB = new Date(b.dettaglio_vendita.data_di_vendita.substr(0,10)).getTime();
                            return this.sortDate === true  && dateA > dateB ? 1 : -1;
                        }
                    })
                }
            }
        },
        methods: {
            initAuctionMapping: function () {
                this.$store.dispatch('auctionmapping/initAuctionMapping');
            },

            resetSearchFilter: function () {
                this.$store.dispatch('auctionmapping/initAuctionMapping');
            },

            setTypologies: function (data) {
                this.$store.dispatch('auctionmapping/setTypologies', data);
            },

            sendSearchFilters: function () {
                this.showLoading = true;
                this.$store.dispatch('auctionmapping/sendSearchFilters', this.rangeValue);
            },

            selectAll: function () {
                let self = this;
                this.isAllSelected = !this.isAllSelected;
                if (this.isAllSelected === true) {
                    this.buildingList.forEach(function (value) {
                        self.checkedBuildings.push(value.link);
                    })
                } else {
                    self.checkedBuildings = [];
                }
            },

            onImportData: function () {
                this.$store.dispatch('auctionmapping/importData');
            },

            handlingSort(sortBy) {
                switch (sortBy) {
                    case 'baseAuction':
                        this.priorityBaseAuction = true;
                        this.sortBaseAuction = !this.sortBaseAuction;
                        this.priorityDate = false;
                        this.sortDate = false;
                        break;
                    case 'date':
                        this.priorityDate = true;
                        this.sortDate = !this.sortDate;
                        this.priorityBaseAuction = false;
                        this.sortBaseAuction = false;
                        break;
                }
            }
        }
    }
</script>

<style scoped>

</style>